import { Mail, MessageCircle, ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useWhatsApp } from "@/lib/siteSettings";
import { SEO } from "@/lib/seo";

const Contact = () => {
  const { t } = useTranslation();
  const { waUrl } = useWhatsApp();

  return (
    <section className="min-h-screen bg-hero-gradient ambient-grid px-4 py-16 sm:px-6 sm:py-24 lg:px-8 lg:py-32">
      <SEO title={t("seo.contact.title")} description={t("seo.contact.description")} path="/contact" />
      <div className="mx-auto grid max-w-6xl items-start gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        <div className="pt-4 lg:pt-8">
          <h1 className="text-balance text-5xl font-black tracking-tight text-foreground sm:text-6xl lg:text-7xl">
            {t("contact.title")}
          </h1>
          <div className="mt-6 h-1 w-20 rounded-full bg-gold-gradient lg:mt-8" />
          <p className="mt-6 max-w-lg text-lg leading-8 text-muted-foreground lg:mt-8">
            {t("contact.subtitle")}
          </p>
        </div>
        <div className="rounded-2xl border border-border/60 bg-surface-elevated/90 p-8 shadow-premium backdrop-blur-xl sm:p-10 lg:p-12">
          <div className="grid gap-5">
            <a
              href={waUrl}
              target="_blank"
              rel="noreferrer"
              className="group relative flex items-center gap-5 overflow-hidden rounded-2xl bg-gold-gradient p-6 text-primary-foreground shadow-premium transition hover:scale-[1.02] hover:shadow-premium lg:p-7"
            >
              <MessageCircle className="h-8 w-8 shrink-0" />
              <span className="flex-1 text-lg font-black sm:text-xl">{t("contact.whatsapp")}</span>
              <ArrowUpRight className="h-5 w-5 shrink-0 opacity-70 transition group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:opacity-100" />
            </a>
            <a
              href="mailto:istanovaaa@gmail.com"
              className="flex items-center gap-4 rounded-xl border border-border/50 bg-card/40 p-5 text-muted-foreground transition hover:bg-secondary/40"
            >
              <Mail className="h-5 w-5 shrink-0 text-primary" />
              <span className="text-sm font-medium sm:text-base">istanovaaa@gmail.com</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
